const ROUTES = {
  //  BASE_URL:"https://778mpekjkk.execute-api.us-east-1.amazonaws.com/stage",
  // BASE_URL: "https://weh4nnvk0g.execute-api.us-east-1.amazonaws.com/stage02",
  BASE_URL: process.env.REACT_APP_BASE_URL,
  // BASE_URL:"https://efze03zxt4.execute-api.us-east-1 .amazonaws.com/stage02",
  // BASE_URL: "http://192.168.100.32:3000/dev",
  // BASE_URL: "http://192.168.100.32:3000/stage02",
  // BASE_URL: "http://localhost:3000/stage02",
  // BASE_URL: "http://192.168.100.29:3000/stage02",
  // BASE_URL: "http://192.168.100.32:3000/stage02",
  // BASE_URL: "http://192.168.100.20:3000/stage02",
  // BASE_URL: "http://192.168.100.22:3000/stage02",
  // BASE_URL:"https://e6f9-39-42-191-103.ngrok-free.app/stage02",
  // BASE_URL:"https://ab49-205-164-155-188.ngrok.io",

  FETCH_ALL_MODULES: "client-module-service/module/all",
  FETCH_ALL_ITEMS: "client-module-service/client-module/list",
  DELETE_ITEM: "client-module-service/client-module",
  FETCH_ALL_ROOMS: "client-module-service/client-module/detail",
  FETCH_FAQ: "dashboard-service/faq/all",
  CREATE_MODULE: "client-module-service/module",
  UPDATE_MODULE: "client-module-service/module",
  SWAP_COLLECTIBLES: "client-module-service/module/swap",
  MODULE_ATTRIBUTES: "client-module-service/attribute/detail",
  REMOVE_MODULE_ATTRIBUTES: "client-module-service/module/attribute/remove",
  IMAGE_UPLOAD: "dashboard-service/upload/file",
  CRETE_CLIENT_ITEM: "client-module-service/client-module",
  UPDATE_CLIENT_ITEM: "client-module-service/client-module/update",
  RECORD_TOTAL: "client-module-service/client-module/total",
  ASSET_FIELDS: "client-module-service/attribute/detail",
  FETCH_ALL_ASSET_ALLOCATION: "client-module-service/module/asset-allocation",
  PERSONAL_INSTRUCTIONS: "death-service/client/personalInstructions",
  CONTACT_LIST: "death-service/client/contact",
  PASSWORDS: "death-service/client/passwords",
  PREPAID_BURIAL: "death-service/client/prepaidBurialExpense",
  BILLS_TO_PAY: "death-service/client/billsToPay",
  LITIGATION: "death-service/client/litigation",
  ACCOUNT_ASSET: "death-service/client/accountAsset",
  PERSONAL_ITEM_LOCATION: "death-service/client/itemLocation",
  CLIENTS_POLICIES: "death-service/client/policies",
  CLIENTS_DOCUMENTS: "death-service/client/clientDocuments",
  CHECKLIST: "death-service/client/checklist",
  SPOUSEINFO: "dashboard-service/client-spouse",
  DEPENDENT_DETAILS: "dashboard-service/client-dependent",
  TRUST_INFO: "dashboard-service/client-trust",
  CORPORATE_INFO: "dashboard-service/client-corporate",
  CHARITY_INFO: "dashboard-service/client-charity",
  OTHER_IMPACTS: "dashboard-service/client-other-impact",
  CREATE_SPOUSE: "dashboard-service/client-spouse",
  CREATE_DEPENDENT: "dashboard-service/client-dependent",
  CREATE_TRUST_INFO: "client-trust",
  CREATE_CORPORATE_INFO: "dashboard-service/client-corporate",
  CREATE_CHARITY_INFO: "dashboard-service/client-charity",
  CREATE_OTHER_IMPACTS: "dashboard-service/client-other-impact",
  UPDATE_SPOUSE_INFO: "dashboard-service/client-spouse",
  EMAIL_TO_SEND: "death-service/client/emails",
  TEXTS_TO_SEND: "death-service/client/texts",
  AUDIO_VIDEO: "death-service/client/audio-video",
  UPDATE_DEPENDENT_INFO: "dashboard-service/client-dependent",
  UPDATE_TRUST_INFO: "dashboard-service/client-trust",
  UPDATE_CORPORATE_INFO: "dashboard-service/client-corporate",
  UPDATE_CHARITY_INFO: "dashboard-service/client-charity",
  UPDATE_OTHER_IMPACTS: "dashboard-service/client-other-impact",
  DELETE_SPOUSE_INFO: "dashboard-service/client-spouse",
  DELETE_DEPENDENT_INFO: "dashboard-service/client-dependent",
  DELETE_TRUST_INFO: "dashboard-service/client-trust",
  DELETE_CORPORATE_INFO: "dashboard-service/client-corporate",
  DELETE_CHARITY_INFO: "dashboard-service/client-charity",
  DELETE_OTHER_IMPACTS: "dashboard-service/client-other-impact",
  ACCOUNT_ASSET_Liabilities: "client-module-service/client-module",
  DOWNLOAD_TEMPLATE: "dashboard-service/export-csv",
  UPLOAD_DOCUMENT: "dashboard-service/upload-csv",
  EXPORT_DOCUMENT: "dashboard-service/export-csv",
  OTP_VERIFY: "auth/verifyOTP",
  OTP_CONFIG: "death-service/send-otp-in-death",
  CONFIRM_DEATH: "death-service/confirm-death",
  DEATH_STATUS: "death-service/client-death-status",
  REVERT_DEATH: "death-service/revert-death-status",
  POST_VIDEO: "death-service/signedUrl",
  POST_PROFILE_PICTURE: "death-service/signedUrl/open",
  POST_TEMPLATE: "dashboard-service/email-template",
  TIMER: "death-service/death-status-revert-time",
  CLIENT_LIST: "dashboard-service/clients-for-delegation-access",
  ADVANCE_HEALTH: "death-service/advance-healthCare-directive",
  SEND_EMAIL: "death-service/send-email-and-text",
  DEATH_CERTIFICATE: "death-service/death-certificate-url",
  TEXT_TEMPLATE: "death-service/text-template",
  SECOND_PASSWORD: "death-service/second-password-granted",
  CLIENT_FUNERAL: "death-service/client-funeral-information",
  EMAIL_LOGS: "death-service/client/emailLogs",
  EMAIL_LOGS_COUNT: "death-service/client/emailLogCounts",
  ACCEPT_INVITATION: "death-service/verifyInvitationCode",
  I_PREFER: "death-service/funeral-wishes/i-prefer",
  PERSONAL_ACCESSORIES: "death-service/funeral-wishes/personal-accessories",
  PLACE_SERVICES: "death-service/funeral-wishes/place-of-service",
  GET_SECURE_LINK: "death-service/getShareDocument",
  SECURE_LINK: "death-service/shareDocument",
  DELETE_SECURELINK: "death-service/deleteShareDocument",
  PROFILE_CHANGE: "dashboard-service/profile-setting",
  GET_PERMISSIONS: "auth-service/permission",
  CREATE_PERMISSION: "auth-service/permission",
  DELETE_PERMISSION: "auth-service/permission",
  UPDATE_PERMISSION: "auth-service/permission",
  GET_ROLELIST: "auth-service/role",
  CREATE_ROLE: "auth-service/role",
  DELETE_ROLE: "auth-service/role",
  UPDATE_ROLE: "auth-service/role",
  GET_USERLIST: "auth-service/admin/user/list",
  UPDATE_USERROLE: "auth-service/user/role",
  CREATE_PLAIDLINKTOKEN: "plaid-service/create/link/token",
  SET_PLAID_PUBLICTOKEN: "plaid-service/client/account/details",
  GET_BANK_DETAILS: "plaid-service/client/bank/details",
  GET_BANK_ACCOUNT: "plaid-service/client/bank/account/details",
  STRIPE_PAYMENT: "stripe-service/stripe/customer/subscription/charge",
  SUBSCRIPTION_DETAILS: "stripe-service/stripe/customer/subscription/details",
  SUBSCRIPTION_LIST: "stripe-service/client/stripe/subscription/list",
  STRIPE_PRODUCTS: "stripe-service/stripe/fetch/products",
  STRIPE_PRODUCTS_LIST: "stripe-service/stripe/products/fetch",
  CANCEL_SUBSCRIPTION: "stripe-service/stripe/cancel/subscription",
  APPLY_PROMO: "stripe-service/apply/promocode",
  CUSTOMER_CARDS: "stripe-service/stripe/customer/cards",
  DELETE_CARD: "stripe-service/stripe/detach/payment-method",
  ADD_TO_PLAN: "plaid-service/add/plaid/to/plan",
  SYNC_ALL_PLAID: "plaid-service/find/match/from/plan",
  SYNC_SINGLE_PLAID: "plaid-service/find/single/record/match",
  SEND_FEEDBACK: "dashboard-service/client/feedback",
  DELETEPLAID_ACCOUNT: "plaid-service/plaid/record/remove",
  GET_COLLECTABLES_COUNT: "client-module-service/client-module/total/count",
  COLLECTABLE_LISTING: "client-module-service/asset/collectibles/listing",
  ADD_CUSTOMER_CARD: "stripe-service/stripe/customer/card",
  MAKE_DEFAULT_CARD: "stripe-service/update/client/payment/method",
  GET_INOVICES: "stripe-service/fetch/invoices",
  DOWNLOAD_INVOICE: "stripe-service/download/invoice/pdf",
  DOWNLOAD_ALL_INVOICES: "stripe-service/download/invoices/pdf",
  GET_GOOGLE_TOKEN: "google/contacts/initiate",
  DELETEALL_ACCOUNTS: "plaid-service/plaid/bank/remove",
  GET_ALL_CONTACTS: "client-contact-service/list/cloud/contacts",
  GET_OUTLOOK_CONTACTS: "client-contact-service/outlook/cloud/contacts",
  GET_GOOGLE_CONTACTS: "client-contact-service/create/google/contacts",
  GET_APPLE_CONTACTS: "client-contact-service/list/apple/contacts",
  CREATE_GROUP: "client-contact-service/group",
  UPDATE_GROUP: "client-contact-service/group/update",
  DELETE_GROUP: "client-contact-service/group/delete",
  GROUP_CONTACTS: "client-contact-service/group/contacts",
  DELETE_CLOUD_CONTACT: "client-contact-service/cloud/contacts/delete",
  UPDATE_CLOUD_CONTACTS: "client-contact-service/cloud/contacts/update",
  CONTACT_GROUPS: "client-contact-service/get/contact/groups",
  ADD_CONTACT_GROUP: "client-contact-service/group/contacts/update",
  EXPORT_CLOUD_CONTACTS: "client-contact-service/export/group/contacts",
  IMPORT_CONTACTS: "client-contact-service/import/group/contacts",
  CREATE_MANUAL_CONTACT: "client-contact-service/create/manual/contact",
  ADD_PASSWORD_SHEET: "death-service/client/password/uploads",
  GET_PASSWORD_SHEET: "death-service/client/password/uploads/list",
  UPDATE_PASSWORD_SHEET: "death-service/client/password/uploads/remove",
  DELETE_SELECTED_CONTACTS: "client-contact-service/cloud/contacts/delete/all",
  SEND_GROUP_EMAILS: "client-contact-service/send/group/email/text",
  GET_PEOPLE_WITH_ACCESS: "dashboard-service/people-with-my-access",
  CANCEL_TRUSTEE_ACCESS: "dashboard-service/revoke/trustees/access",
  ADD_CONTACTS_FROM_CLIENT:
    "client-contact-service/add/cloud/contacts/to/death/contact",
  ADD_CONTACTS_FROM_GROUP:
    "client-contact-service/add/group/contacts/to/death/contact",
  CREATE_CATEGORY: "budget-service/categories",
  CREATE_BUDGET: "budget-service/budget",
  UPDATE_BUDGET: "budget-service/budget/update",
  DELETE_BUDGET: "budget-service/budget/remove",
  GET_TRANSACTION: "budget-service/transactions/fetch",
  CREATE_TRANSACTION: "budget-service/transactions/create",
  UPDATE_TRANSACTION: "budget-service/transactions/update",
  DELETE_TRANSACTION: "budget-service/transactions/delete",
  DASHBOARD_BUDGET: "budget-service/budget/dashboard",
  CALCULATED_BUDGET: "budget-service/monthly/budget/calculate",
  FILTER_TRANSACTION: "budget-service/transactions/filter",
  FILTER_BUDGET: "budget-service/budget/filter",
  GET_TRANSACTION_HISTORY: "budget-service/transactions/history",
  GET_RECURRING_TRANSACTION: "budget-service/recurring/transactions",
  DELETE_RECURRING: "budget-service/recurring/delete",
  HIDE_RECURRING: "budget-service/hide/recurring",
  UNHIDE_RECURRING :"budget-service/unhide/recurring",
  UPLOAD_TRANSACTION: "plaid-service/info",
  REFRESH_BANK: "plaid-service/balance/update",
  DELETE_LINK_TRANSACTIONS: "client-module-service/module/delete/transactions",
  DELETE_LINK_MODULES: "client-module-service/transactions/delete/modules",
  FETCH_ASSET_LOAN: "fetch/assets/with/loan",
  UPDATE_ASSET_GOAL: "client-module-service/client-module/update_goal",
  DELETE_GOAL: "client-module-service/client-module/remove_goal",
  SEARCH_BANK: "plaid-service/search/institution",
  GET_PLAID_BANKS: "plaid-service/get/institutions",
  REMOVE_ASSIGN_ASSET: "client-module-service/goal/remove_assigned_asset",
  ASSIGN_ASSET: "client-module-service/goal/assign_asset",
  FETCH_SINGLE_GOAL: "client-module-service/goal/record",
  UPDATE_ASSIGN_ASSET: "client-module-service/client-module/update/goal/assets",
  GET_UPDATED_ROLE: "auth-service/me",
  GET_ASSET_MONETARY_VALUE: "dashboard-service/fetch/assets/monetary",
  GET_EXPANSES: "budget-service/transactions/expenses",
  GET_TOP_EXPANSES: "budget-service/higher/expense/transactions",
  GET_FILTER_GOALS: "dashboard-service/fetch/goals",
  GET_FILTER_BUDGET: "dashboard-service/fetch/budget",
  UPADTE_USER_ASSET_SETTING: "dashboard-service/update/setting",
  GET_FILTER_DEBT: "dashboard-service/fetch/debt",
  POST_DEBT_DATA: "dashboard-service/debt/data",
  REFRESH_LIABILITY: "plaid-service/update/module/from/plaid",
  PLAID_UPDATED_BALANCE: "budget-service/transactions/credit/balance",
  GOOGLE_AUTH_LOGIN: "dashboard-service/google/auth",
  GOOGLE_SAVE_TOKEN: "dashboard-service/google/auth/token",
  GET_DASHBOARD_TASKS: "dashboard-service/tasks",
  UPDATE_DASHBOARD_TASK_STATUS: "dashboard-service/update/tasks",
  CREATE_DASHBOARD_TASK: "dashboard-service/create/tasks",
  CREATE_DASHBOARD_EVENT: "dashboard-service/event",
  UPDATE_DASHBOARD_EVENT: "dashboard-service/update/event",
  GET_DASHBOARD_EVENT: "dashboard-service/events",
  GET_STOCKS_LIST: "dashboard-service/investments/transactions",
  GET_TAX_CREDIT: "client-module-service/tax_credits",
  CREATE_TAX_CREDIT: "client-module-service/tax_credits",
  DELETE_TAX_CREDIT: "client-module-service/tax_credits",
  DELETE_GOOGLE_TASK: "dashboard-service/delete/tasks",

  GET_INSURANCE_STATS: "client-module-service/insurance/stats",
  GET_INSURANCE_SUM: "client-module-service/insurance/sum",
  GET_INSURANCE_CHART: "client-module-service/insurance/chart",
  GET_TAX_INFLATION: "client-module-service/tax_inflation",
  CREATE_TAX_INFLATION: "client-module-service/tax_inflation",
  CREATE_CARRY_FORWARD: "client-module-service/carry-forward/asset",
  CREATE_CARRY_FORWARD_Tax: "client-module-service/carry-forward/tax-return",
  GET_NEWS: "dashboard-service/news",
  CREATE_RATE_OF_RETURN: "client-module-service/rates-of-return",
  USER_DEFINED_DETAILS: "client-module-service/user/defined/average",
  USER_DEFINED: "client-module-service/user-defined",
  USER_ATTACHED_DOCS: "client-module-service/documents",
  GET_MONETARY_VALUE: "dashboard-service/assets/type/monetary-value",
  UPLOAD_IMP_DOCUMENT: "client-module-service/upload/imp/document",
  GET_IMP_DOCUMENT: "client-module-service/imp/document",
  UPDATE_IMP_DOCUMENT: "client-module-service/move/imp/document",
  DELETE_IMP_DOCUMENT: "client-module-service/delete/imp/document",
  COUNT_IMP_DOCUMENT: "client-module-service/imp/document/count",
  GET_LIQUID_ASSETS: "client-module-service/client-module/liquid",
  GET_USERS_LIST: "auth-service/admin/user/list",
  CHAT_INVITE: "chat-service/send/chat-invite",
  ACCEPT_CHAT_INVITE: "chat-service/accept/chat-invite",
  DECLINE_CHAT_INVITE: "chat-service/decline/chat-invite",
  CANCEL_CHAT_INVITE: "chat-service/cancel/chat-invite",
  DELETE_CHAT_INVITE: "chat-service/delete/chat-invite",
  FETCH_CHAT_HISTORY: "chat-service/chat-history",
  CHAT_WITH_USER: "chat-service/chat",
  CHAT_USER_INVITED_LISTED:"chat-service/users/invited-list",
  FETCH_FUTURE_LOAN:"client-module-service/client-module/future-loan",
  CALCULATE_LOAN_SUM:"client-module-service/liability-credit/sum",
  CALCULATE_LIABILITY_CREDIT_SUM:"client-module-service/liability-credit/module/sum",
  LIABILITY_CREDIT_HIGHER_VALUES:"client-module-service/liability-credit/higher/values",
  COLLECTABLES_VALUE: "client-module-service/monetaryValue/collectibles/modules",
  COLLECTABLES_DELETE: "client-module-service/collectible/modules",
  USER_TYPING: "chat-service/typing",
  UNREAD_CHAT_COUNT:"chat-service/chat-count",
  INCOME_TOTAL_SUM: "client-module-service/calculate/total-income",
  INCOME_CHART: "client-module-service/income/chart",
  BUDGET_CHART: "budget-service/income/expense",
  GET_ALL_BUDGETS: "budget-service/budget/all",
  GET_ALL_TRANSACTION_CATEGORIES: "budget-service/transactions/category",
  GET_ALL_TRANSACTION_SUB_CATEGORIES: "budget-service/transactions/sub/category",
  GET_ALL_TRANSACTIONS:"budget-service/transactions",
  CREATE_TRANSACTION_V2: "budget-service/transactions",
  CALCULATED_BUDGET_TRANSACTIONS:"budget-service/monthly/budget",
  RECURRING_TOKEN:"budget-service/recurring/token",
  RECURRING_TOKEN_UPDATE:"budget-service/recurring/token/pattern",
  SYSTEM_RECURRING_TRANSACTIONS:"budget-service/transactions/recurring",
  UPADTE_MONTHLY_BUDGET: "budget-service/monthly/budget",
  GET_FILTER_TRANSACTIONS: "budget-service/transactions",
  TRANSACTIONS_RULE: "budget-service/transaction/rule",
  PAST_RECURRING: "budget-service/past/recurring/transaction",
  RULE_TRANSACTIONS:"budget-service/rule/transaction",
  RECURRING_CATEGORY_TRANSACTIONS:"budget-service/transactions/recurring/category",
  SEARCH_RECURRING_CATEGORY_TRANSACTIONS:"budget-service/recurring/transactions/all",
  RECURRING_CATEGORY_TRANSACTIONS_CREATE:"budget-service/recurring/transactions/create",
  RECURRING_PREDICTION_TRANSACTIONS:"budget-service/predicted/recurring/transactions",
  RECURRING_FOUND_TRANSACTIONS:"budget-service/recurring/transactions/list",
  ADD_NEW_ADVISOR_CLIENT: "auth-service/auth/add/client",
  RESET_PASSWORD:"auth-service/change-password",
  GET_AVISOR_CLIENT_LISTING: "auth-service/auth/client/list",
  DELETE_ADVISOR_CLIENT:"auth-service/auth/delete/client",
  USER_TOTAL_INCOME_EXPENSE:"client-module-service/total/income/expense",
  USER_MONTHLY_SAVING:"client-module-service/total/monthly/saving/goals",
  MODULE_BALANCE:"client-module-service/client-module/loan/balance",
  CHAT_DOWNLOAD:"chat-service/export/conversation",
  COLLECTION_SAMPLE_DOWNLOAD:"client-module-service/client-module/export",
  LOAN_ITEM:"client-module-service/loan/create",
  BORROW_ITEM:"dashboard-service/borrowitem/create",
  LOAN_ITEM_UPDATE:"client-module-service/loan/update",
  ACTIVATE_FINANCIAL_ADVISOR_CLIENT:"auth-service/auth/activate/client",
  DEACTIVATE_FINANCIAL_ADVISOR_CLIENT:"auth-service/auth/deactivate/client",
  RESEND_INVITATION:"auth-service/auth/resent-invitation",
  REFRESH_CLIENT_DATA:"auth-service/auth/client/plaid",
  MODULE_STOCKS:"plaid-service/module/stocks",
  REPORT_BUDGET_SUMMED:"budget-service/budget/summed",
  TRANSACTION_REPORTS:"budget-service/transactions/report",
  DELETE_ACCOUNT:"auth-service/delete-account",
  FETCH_ACCOUNT_DELETION_REQUESTS:"auth-service/fetch-account-deletion-requests",
  REVERT_ACCOUNT_DELETION_REQUEST:"auth-service/cancel-account-deletion",
  CHECK_PLAID_COOL_DOWN:"plaid-service/check/cool-down",
  PLAID_WEBHOOK_UPDATES:"plaid-service/plaid/webhook/updates",
  PLAID_LOGS:"plaid-service/plaid/logs",
  PLAID_ACCOUNT_UPDATE:"plaid-service/plaid/webhook/process",
  PLAID_COST_CONFIG:"plaid-service/plaid/cost/config",
  PLAID_PRODUCT_PRICING:"plaid-service/plaid/cost/product-pricing",
  RAG_DOCUMENT_INJESTION:"ai-rag-service/documents/ingest",
  RAG_DOCUMENT_SEARCH:"ai-rag-service/search",
  RAG_SEARCH:"ai-rag-service/search",
  PLAID_SYNC_STATUS:"plaid-service/plaid/sync/status",
  PROSPECT_PASS_STATUS:"auth-service/auth/prospect-pass/status",
  ADVISOR_CLIENTS__BANK_LISTING:"auth-service/auth/client/bank-accounts",


};

export default ROUTES;
